import React, { Component } from 'react';
import { Collapse, Container } from 'reactstrap';

class ContactUs extends Component {
    constructor(props) {
        super(props)

        this.state = {
            isOpen: false
        }
    }

    toggle = () => {
        this.setState({
            isOpen: !this.state.isOpen
        })
    }
    render() {
        return (
            <div className="collapsible-main">
                <div onClick={this.toggle}>
                    <h4 className="collapsible-header">Contact Us</h4>
                    {
                        this.state.isOpen ? <a aria-label='Contact Us' href='javascript:;' className="eir-icon chevron-arrow icon-arrowup--purple float-right"> </a> : <a aria-label='Contact Us' href='javascript:;' className="eir-icon chevron-arrow icon-arrowdown--purple float-right"> </a>
                    }

                </div>
                <Collapse isOpen={this.state.isOpen}>
                    <br />
                    <div className="collapsible-item">
                        For help with any of the below, contact us on <b className='text-nowrap'>1800 201 042</b>
                        <li>Billing</li>
                        <li>My Account</li>
                        <li>Service issue</li>
                        <li>Cancellation</li>
                    </div>
                </Collapse>
            </div>
        )
    }
}

export default ContactUs;
